import React, {Component}    from 'react';
import PropTypes from 'prop-types';

class MultipleCheckBoxes extends Component {
    constructor(props){
        super(props);

        this.state = {
            names: [],
            values: []
        };

        this.handleInputChange = this.handleInputChange.bind(this);
    };

    componentDidMount() {
        this.setState({
            names: this.props.names,
            values: this.props.defaultChecked ? this.props.defaultChecked : []
        })
    }

    handleInputChange(event) {
        const target = event.target;
        var value = target.value;

        if (target.checked) {
            this.setState({
                values: [...this.state.values, value]
            }, () => {
                if (this.props.onChange) {
                    this.props.onChange(this.state.values);
                }
            })
        } else {
            var idx = this.state.values.indexOf(value);
            if (idx != -1) {
                this.state.values.splice(idx, 1);
                if (this.props.onChange) {
                    this.props.onChange(this.state.values);
                }
            }
        }
    }

    render() {

        return (
            <div>
                {this.state.names.map((name, idx) => {
                    return <div key={`m_cb_${idx}`}>
                        <input type="checkbox" 
                            value={name} 
                            onChange={this.handleInputChange}
                            defaultChecked={this.state.values.indexOf(name) != -1 ? true: false}
                            disabled={this.props.disabled}>
                        </input>
                        <label> {name}</label>
                    </div>
                })}
            </div>
        );
    };
}

MultipleCheckBoxes.defaultProps = {
    disabled: false
}

MultipleCheckBoxes.propTypes = {
    onChange: PropTypes.func,
    names: PropTypes.array.isRequired,
    defaultChecked: PropTypes.array,
    disabled: PropTypes.bool
};

export default MultipleCheckBoxes;


